import { atom } from 'jotai';

type BrokeredOrderFileCreateParams = {
  brokeredOrderId: string;
  fileName: string;
  fileSize: number;
  mimeType: string;
};

type BrokeredOrderFileCreateResult = {
  brokeredOrderFileCreate: {
    file: {
      id: string;
      fileName: string;
      fileSize: number;
      mimeType: string;
      status: string;
    };
    uploadUrl: string;
  };
};

export const brokeredOrderFileCreateMutationAtom = () =>
  atom(
    null,
    async (
      _get,
      _set,
      _params: BrokeredOrderFileCreateParams,
    ): Promise<BrokeredOrderFileCreateResult> => {
      throw new Error(
        'Not implemented: brokeredOrderFileCreate backend API pending',
      );
    },
  );
